// extracted by mini-css-extract-plugin
export var addButton = "_pa-0";
export var border = "_pa-8";
export var check = "_pa-h";
export var danger = "_pa-6";
export var dropdownContainer = "_pa-1";
export var editModalBody = "_pa-j";
export var footerContainer = "_pa-i";
export var fullWidth = "_pa-a";
export var hide = "_pa-9";
export var icon = "_pa-3";
export var input = "_pa-7";
export var inputFlex = "_pa-b";
export var inputWrapper = "_pa-c";
export var manualFocus = "_pa-5";
export var optionButton = "_pa-4";
export var pillWrapper = "_pa-e";
export var pointer = "_pa-2";
export var showOverflow = "_pa-f";
export var tagsFlex = "_pa-d";
export var xButton = "_pa-g";